import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { smartAlert } from "../lib/confirm-alert";
import { getAppConfig } from "../config";
import { URL_PATHS } from "../routes";
import * as urls from "../shared/urls";

export function useEmailUnsubscribePage() {
    const config = getAppConfig();
    const [body, setBody] = useState<{
        userId: string;
        unsubscribeToken: string;
    } | null>(null);
    const [loading, setLoading] = useState(false);
    const [unsubscribeFinish, setUnsubscribeFinish] = useState(false);

    const { search } = useLocation();
    const history = useHistory();

    useEffect(() => {
        const { userId, unsubscribeToken } = urls.parseSearchQuery(search);
        if (!userId || !unsubscribeToken) {
            smartAlert("URLが不正です。").then();
            history.replace(URL_PATHS.myPage());
            return;
        }
        setBody({
            userId,
            unsubscribeToken
        });
    }, [search]);

    return {
        query: {
            unsubscribeFinish,
            loading
        },
        usecase: {
            onRequestEmailUnsubscribe: async () => {
                if (!body) {
                    throw new Error("不正な状態です。");
                }
                setLoading(true);
                const res = await fetch(
                    `${config.apiBaseUrl}/email_unsubscribe`,
                    {
                        method: "PUT",
                        body: JSON.stringify(body),
                        headers: {
                            "content-type": "application/json"
                        }
                    }
                );
                setLoading(false);
                if (res.status >= 400) {
                    await smartAlert(
                        "エラーが発生しました。もう一度お試しください。"
                    );
                    return;
                }
                setUnsubscribeFinish(true);
            }
        }
    };
}
